import { useEffect, useState } from 'react';
import firebase from '../../firebaseConnection';

import { Container, Content, Recado } from './styles';

export function Recados() { 
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [recados, setRecados] = useState([])

    useEffect(() => {
        function loadRecados() {
            firebase.firestore().collection('recados')
            .onSnapshot((rec) => {
                let meusRecados = [];

                rec.forEach((item) => {
                    meusRecados.push({
                        id: item.id,
                        name: item.data().name,
                        description: item.data().description,
                    })
                })
                setRecados(meusRecados)
            })
        }
        loadRecados()
    }, [])
    
     async function handleSubmit() {
         await firebase.firestore().collection('recados')
        .add({
            name: name,
            description: description
        })
        .then(() => {
            setName('');
            setDescription('');
        })
        .catch((error) => {
            console.log('Gerou um erro:', error)
        })
    }
    
    var mapped = recados.map(function(el, i) {
        return { index: i, value: el };
    })

    mapped.sort(function(a, b) {
        return +(a.value > b.value) || +(a.value === b.value) - 1;
    });

    var recadosOrdenado = mapped.map(function(el){
        return recados[el.index];
    });
    
    return (
        <Container id="recado">
            <h1>Recado para os noivos</h1>            
            <Content>
                <label htmlFor="nome">Nome:</label>
                <input type="text" id="nome" value={name} onChange={(e) => setName(e.target.value)}/>
                <label htmlFor="mensagem">Recado:</label>
                <textarea name="Recado" id="mensagem" cols="30" rows="10" value={description} onChange={(e) => setDescription(e.target.value)}></textarea>

                <button type="button" onClick={handleSubmit}>Enviar recado</button>
            </Content>

            <Recado>
                <ul>
                    {recadosOrdenado.map(recado => (                    
                        <li key={recado.id}>
                            <div>
                                <h3>{recado.name}</h3>
                                <p>{recado.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </Recado>
        </Container>
    );
}